<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dailyTaskUpdateReport.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dailyTaskUpdateReport.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('dailyTaskUpdateReport.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('dailyTaskUpdateReport.dateRange')
                          }}</label>
                          <a-range-picker
                            format="DD-MM-YYYY"
                            :defaultValue="rangeDate"
                            :defaultPickerValue="rangeDate"
                            @change="dateRangeChange"
                            :ranges="{
                              Today: [moment(), moment()],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyTaskUpdateReport.project')
                          }}</label>
                          <a-select
                            v-model="model.project_id"
                            :options="projects"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('dailyTaskUpdateReport.task') }}</label>
                          <a-select
                            v-model="model.task_id"
                            :options="tasks"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('dailyTaskUpdateReport.site') }}</label>
                          <a-select
                            v-model="model.id"
                            :options="sites"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{ $t('dailyTaskUpdateReport.owner') }}</label>
                          <a-select
                            v-model="model.employee_id"
                            :options="owners"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyTaskUpdateReport.status')
                          }}</label>
                          <a-select
                            v-model="model.status_id"
                            :options="status"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyTaskUpdateReport.customer')
                          }}</label>
                          <a-select
                            v-model="model.customer_id"
                            :options="customers"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            placeholder="All"
                            mode="multiple"
                            class="ts-w-full"
                          >
                          </a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('dailyTaskUpdateReport.phoneNumber')
                          }}</label>
                          <input
                            type="text"
                            v-model="model.contact_number"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row form-group">
											<a-radio-group v-model="model.report_type" class="col-md-12">
												<a-radio-button value="1" class="col-md-6">Versoin 1</a-radio-button>
												<a-radio-button value="2" class="col-md-6">Versoin 2</a-radio-button>
											</a-radio-group>
										</div> -->
                    <div class="row ts-mt-3">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf text-red"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('dailyTaskUpdateReport.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'daily-task-update',
  data() {
    return {
      waiting: false,
      loading: false,
      exporting: false,
      errors: new Errors(),
      src: '',
      rangeDate: [moment(), moment()],
      projects: [],
      tasks: [],
      sites: [],
      products: [],
      owners: [],
      status: [],
      customers: [],
      model: {
        report_type: '1',
        contact_number: null,
        project_id: undefined,
        id: undefined,
        product_id: undefined,
        employee_id: undefined,
        task_id: undefined,
        status_id: undefined
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('report/project', [
      'getProject',
      'getSite',
      'getProduct',
      'getOwner',
      'getStatus',
      'getCustomer',
      'getTask'
    ]),
    moment,
    dateRangeChange(rangeDate) {
      this.$store.commit(
        'report/project/SET_DATE_FROM',
        rangeDate[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'report/project/SET_DATE_TO',
        rangeDate[1].format('DD-MM-YYYY')
      )
    },
    async fetchData() {
      this.loading = true
      await this.getProject()
        .then(response => {
          this.projects = response.map(el => ({
            value: el.project_id,
            label: el.project_name
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getSite()
        .then(response => {
          this.sites = response.map(el => ({
            value: el.id,
            label: el.site_name
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getProduct()
        .then(response => {
          this.products = response.map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getOwner()
        .then(response => {
          this.owners = response.map(el => ({
            value: el.employee_id,
            label: el.employee_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getStatus()
        .then(response => {
          this.status = response.map(el => ({
            value: el.status_id,
            label: el.project_status
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getCustomer()
        .then(response => {
          this.customers = response.map(el => ({
            value: el.customer_id,
            label: el.customer_name
          }))
        })
        .finally(() => {
          this.loading = false
        })
      await this.getTask()
        .then(response => {
          this.tasks = response.map(el => ({
            value: el.id,
            label: el.title
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/project/dailyTaskUpdate', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/project/dailyTaskUpdateExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
